/**
 * @author wql
 * @date 2020-10-21
 * @desc 学分  科目查看
 */
import React from "react";
import { connect } from 'dva';
import { Descriptions } from 'antd';
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { WizAuthority } from "../../../common";

let { WizContainer, modelUtils, WizAvatarUpload, ossFileUtils } = framework_tool
let { WizCard, WizSelect, WizForm, Wizmessage, WizRow, WizCol, WizInput, WizSpin } = component_tool
let { Session } = utils_tool

class SubjectInfo extends WizContainer {
  componentName = 'liveInfo'

  constructor(props) {
    super(props)
    const { history } = props
    let detailInfo = {};
    if (history.location && history.location.pathname === '/credit/subjectList/SubjectInfo') {
      if (history.location && history.location.record) {
        detailInfo = history.location.record
        Session.set('SubjectInfo', detailInfo)
      } else {
        detailInfo = Session.get('SubjectInfo') || {}
      }
    }
    this.state = {
      time: undefined
    }
    this.detailInfo = detailInfo
  }

  _componentDidMount() {
    if (this.detailInfo.id) {
      this.doAction({
        path: 'subject/getInfoById',
        payload: {
          key: "getLiveInfo",
          apiParams: {
            id: this.detailInfo.id
          }
        }
      });
    }
  }

  propsAndStateOnChange = {
    liveInfo: this._getLiveInfoOver.bind(this)
  }

  _getLiveInfoOver(nextProps, nextState) {
    if (nextProps.liveInfo.code == 1) {
      this.detailInfo = nextProps.liveInfo.data;
      nextState.time = new Date().getTime();
    }
    return true;
  }


  getImgInfo = () => {
    let record = this.detailInfo
    let url = getOssFilePath(record['img'])
    // ossFileUtils.getOssFile(
    //   record.img,
    //   record.fileName,
    //   record.fileMimeType,
    //   record.fileSize,
    //   record.fileUri,
    // ).url
    url = record.img ? url : constants.files.sys_img_loadingFailed;
    return <div style={{ display: 'flex', 'justify-content': 'flex-start', marginRight: 0, }}>
      <div>
        <img height={225} width={400} src={url} />
      </div>
    </div>
  }


  _render() {
    const items = this.detailInfo
    return (
      <React.Fragment>
        <WizSpin tip={'加载中'} spinning={this.props.interactLiveLoading}>
          <WizCard>
            <Descriptions column={1}  bordered={true}>
              <Descriptions.Item label='名称'>{items.name}</Descriptions.Item>
              <Descriptions.Item label='分类'>{items.categoryName}</Descriptions.Item>
              <Descriptions.Item label='类型'>{items.type == 1 ? '必修' : '选修'}</Descriptions.Item>
              <Descriptions.Item label='直播受众'>{<WizAuthority value={items.authInfo} mode='Show' showBlock={false} />}</Descriptions.Item>
              <Descriptions.Item label='介绍'>{items.intro}</Descriptions.Item>
              <Descriptions.Item label='直播状态'>{items.state == 0 ? '无效' : '有效'}</Descriptions.Item>
              <Descriptions.Item label='创建时间'>{items.createTime}</Descriptions.Item>
            </Descriptions>
          </WizCard>
        </WizSpin>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { interactLive,subject } = state;
  const liveInfo = modelUtils.getModelEntity(subject, "getLiveInfo");
  const load = modelUtils.getLoadingState(state, ['interactLive']);
  return {
    liveInfo,
    ...load
  }
};

export default connect(mapStateToProps)(SubjectInfo)

